import request from "../../untils/request.js"


export const getAllDept = (params) => {
    return request.get("/outpatient/findAttribute", {params} )
}


export const getAllReservation = (params) => {
    return request.get("/outpatient/register/page", {params} )
}

//挂号列表
export const getRegisterType = (params) => {
    return request.get("/outpatient/registertype/list", {params} )
}

//医生列表
export const getDoctorList = (params) => {
    return request.get("/outpatient/list", {params} )
}

//医生列表
export const getRoleList = (params) => {
    return request.get("/outpatient/role/list", {params} )
}

//挂号退款
export const registrationRefund = (data) => {
    return request.post("/outpatient/register/refund", data )
}

export default{

}